// extracted by mini-css-extract-plugin
export var banner = "styles-module__banner___P2WEs";
export var bookmarkButton = "styles-module__bookmarkButton___ecQ7b";
export var container = "styles-module__container___f1liH";
export var dateAndActivity = "styles-module__dateAndActivity___HyeGo";
export var description = "styles-module__description___xOSFS";
export var metadata = "styles-module__metadata___QHuNx";
export var name = "styles-module__name___aLM1C";
export var nameAndDescription = "styles-module__nameAndDescription___vxiRq";
export var nameAndStars = "styles-module__nameAndStars___Ae6fz";
export var starsBlock = "styles-module__starsBlock___SJJrn";
export var trackName = "styles-module__trackName___I0K1Q";